import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HTTPService, HelperService } from 'app/services';
import { DateService } from 'app/services/date.service';
import { datetimeFormat } from 'app/constants/date-time-format';

@Component({
  selector: 'app-reassign-dialog',
  templateUrl: './reassign-dialog.component.html',
  styleUrls: ['./reassign-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReassignDialogComponent implements OnInit {
  service: any = {};
  orderId:any = ''
  primaryTechInprogress:boolean = false
  hOneTechInprogress:boolean = false
  hTwoTechInprogress:boolean = false
  primary:boolean = false
  helper1:boolean = false
  helper2:boolean = false;

  selected:boolean = true

  constructor(
    public dConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService,
    public dataService: DataService,
    private dateService: DateService
  ) {}

  ngOnInit() {
    this.service = this.dConfig.data.service;
    this.orderId =  this.dConfig.data.orderId;
  }

  closeDuplicateVehicleeModal(data: any) {
    this.ref.close({ });
  }

  handleRadioChange(value,key) {
    if(key==='primary'){
      if(this.service.tech && this.service.tech.workStatus === 'inprogress'){
        this.primaryTechInprogress = true;
        this.primary = true
        this.helper1 = false
        this.helper2 = false
      }else {
        this.primary = true
        this.helper1 = false
        this.helper2 = false
      }
    } else if(key === 'helper1') {
      if(this.service.hTechOne && this.service.hTechOne.workStatus === 'inprogress'){
        this.hOneTechInprogress = true;
         this.helper1 = true;
        this.helper2 = false;
        this.primary = false;
      }else {
        this.helper1 = true;
        this.helper2 = false;
        this.primary = false;
      }
    } else if(key === 'helper2') {
      if(this.service.hTechTwo && this.service.hTechTwo.workStatus === 'inprogress'){
        this.hTwoTechInprogress = true;
        this.helper1 = false;
        this.primary = false
        this.helper2 = true
      }else {
        this.helper1 = false;
        this.primary = false
        this.helper2 = true
      }

    }
  }

  handleSubmit() {
    let data = {}
     if(this.primary){
      if(this.service.tech && this.service.tech.workStatus === 'inprogress'){
        return
      } else {
        data = {
          tech: {
            initials: 'PT',
            name:this.service.tech.name,
            role: 'primary',
            techId: this.service.tech.techId
          },
          serviceId: this.service.serviceId
        }
      }
    }

    if(this.helper1){
      if(this.service.hTechOne && this.service.hTechOne.workStatus === 'inprogress'){
        return
      } else {
        data = {
          tech: {
            initials: 'H1',
            name:this.service.hTechOne.name,
            role: 'helper1',
            techId: this.service.hTechOne.techId
          },
          serviceId: this.service.serviceId
        }
      }
   }

   if(this.helper2){
    if(this.service.hTechTwo && this.service.hTechTwo.workStatus === 'inprogress'){
      return
    } else {
      data = {
        tech: {
          initials: 'H2',
          name:this.service.hTechTwo.name,
          role: 'helper2',
          techId: this.service.hTechTwo.techId
        },
        serviceId: this.service.serviceId
      }
    }

 }

 this.httpService
      .reassignTech(this.orderId,data)
      .then(
        (data: any) => {
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.closeDuplicateVehicleeModal({})
      });

  }

}
